__turbopack_context__.v({
  "accordionSlideOverwrite": "navigationSubMenu-module-scss-module__sGDYLW__accordionSlideOverwrite",
  "endIconBubble": "navigationSubMenu-module-scss-module__sGDYLW__endIconBubble",
  "fadeIn": "navigationSubMenu-module-scss-module__sGDYLW__fadeIn",
  "fadeOut": "navigationSubMenu-module-scss-module__sGDYLW__fadeOut",
  "featuredColumn": "navigationSubMenu-module-scss-module__sGDYLW__featuredColumn",
  "groupHeader": "navigationSubMenu-module-scss-module__sGDYLW__groupHeader",
  "groupTitle": "navigationSubMenu-module-scss-module__sGDYLW__groupTitle",
  "itemsWrap": "navigationSubMenu-module-scss-module__sGDYLW__itemsWrap",
  "navigationSubMenu": "navigationSubMenu-module-scss-module__sGDYLW__navigationSubMenu",
  "popoverAnchor": "navigationSubMenu-module-scss-module__sGDYLW__popoverAnchor",
  "popoverContent": "navigationSubMenu-module-scss-module__sGDYLW__popoverContent",
  "scaleIn": "navigationSubMenu-module-scss-module__sGDYLW__scaleIn",
  "scaleOut": "navigationSubMenu-module-scss-module__sGDYLW__scaleOut",
  "section": "navigationSubMenu-module-scss-module__sGDYLW__section",
  "sectionLabel": "navigationSubMenu-module-scss-module__sGDYLW__sectionLabel",
  "sectionsWrap": "navigationSubMenu-module-scss-module__sGDYLW__sectionsWrap",
  "sublink": "navigationSubMenu-module-scss-module__sGDYLW__sublink",
  "sublinkDescription": "navigationSubMenu-module-scss-module__sGDYLW__sublinkDescription",
  "sublinkGroup": "navigationSubMenu-module-scss-module__sGDYLW__sublinkGroup",
  "sublinkTitle": "navigationSubMenu-module-scss-module__sGDYLW__sublinkTitle",
  "trigger": "navigationSubMenu-module-scss-module__sGDYLW__trigger",
  "zoomIn": "navigationSubMenu-module-scss-module__sGDYLW__zoomIn",
  "zoomOut": "navigationSubMenu-module-scss-module__sGDYLW__zoomOut",
});
